const initializeFlockMobileAtc = (bar) => {
  if (bar.dataset.initialized === 'true') return;

  const sectionId = bar.dataset.sectionId;
  const stickyButton = bar.querySelector('.flock-mobile-atc__button');
  const stickyPrice = bar.querySelector('.flock-mobile-atc__price');
  const productInfo = document.getElementById(`ProductInfo-${sectionId}`);

  if (!stickyButton || !stickyPrice || !productInfo) return;

  const sync = () => {
    const nativeButton = document.getElementById(bar.dataset.nativeButtonId);
    const priceContainer = document.getElementById(bar.dataset.priceId);
    const currentPrice =
      priceContainer?.querySelector('.price__sale .price-item--sale') ||
      priceContainer?.querySelector('.price-item--regular');

    if (nativeButton) {
      stickyButton.disabled = nativeButton.disabled;
      stickyButton.textContent = nativeButton.querySelector('span')?.textContent.trim() || nativeButton.textContent.trim();
    }

    if (currentPrice) {
      stickyPrice.textContent = currentPrice.textContent.trim();
    }
  };

  stickyButton.addEventListener('click', () => {
    document.getElementById(bar.dataset.nativeButtonId)?.click();
  });

  const observer = new MutationObserver(sync);
  observer.observe(productInfo, {
    attributes: true,
    childList: true,
    subtree: true,
  });

  bar.dataset.initialized = 'true';
  sync();
};

const initializeFlockPdp = (root = document) => {
  root.querySelectorAll('[data-flock-mobile-atc]').forEach(initializeFlockMobileAtc);
};

initializeFlockPdp();

document.addEventListener('shopify:section:load', (event) => {
  initializeFlockPdp(event.target);
});
